import { createReducer } from '@reduxjs/toolkit';

import { dialogClosed } from 'Core/actions/dialog';
import { vehicleDiscardingRequested, vehicleSelected } from 'Core/actions/fitmentSearch/index';
import { fitmentResponseInitState, fitmentResponseReducer } from 'Core/reducers/fitmentSearch/common';

const initState = fitmentResponseInitState;

export default createReducer(initState, (builder) =>
  builder
    .addCase(dialogClosed, () => initState)
    .addCase(vehicleDiscardingRequested, () => initState)
    .addCase(vehicleSelected, () => initState)
    .addDefaultCase((state, action) => fitmentResponseReducer(state, action)),
);
